<section class="main-section dashboard-section deskContent">
  <div class="row align-items-end">
    <div class="col-10">
      <h2>Orders</h2>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md mb-2 mb-md-0" style="position: relative;" (click)="navigateToOrder('submitted')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.createdCount || 0}}</span>
          <small>Created</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('InProcess')">
      <div class="box">
        <h1 style="z-index: 1100; min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.inProcessCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#2bedbc"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>Processing</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('shipped')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.shippedCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#f14a03"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>In Transit</small>
        </h1>
      </div>
    </div>
    <div class="col-md  mb-2 mb-md-0" style="position: relative;" (click)="navigateToOrder('Delivered')">
      <div class="box ">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.deliveredCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#07be06"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>Delivered</small>
        </h1>
      </div>
    </div>
    <div class="col-md mb-2 mb-md-0 " style="position: relative;" (click)="navigateToOrder('Cancelled')">
      <div class="box ">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.exceptionCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#f3ed03"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>With Exceptions</small>
        </h1>
      </div>
    </div>

  </div>
  <div class="mw-100% d-flex flex-row justify-content-between deskContent" style="height:250px">
    <div class="box me-1 col rounded-sm">
      <h4>NDR</h4>
      <div class="row d-flex justify-content-around">
        <div class="col-sm-3">
          1st Attempt
        </div>
        <div class="col-sm-3">
          2nd Attempt
        </div>
        <div class="col-sm-3">
          3rd Attempt
        </div>
      </div>
    </div>
    <div class="box col float-right rounded-sm ml-3" style="height:250px;">
      <h4>Returns</h4>
      <div class="row  d-flex justify-content-around">
        <div class="col-sm-2">
          <h1><span>{{orders?.rtoCount || 0}}</span>
            <small style="width:200px; margin-left:-50px">RTO (Returned to Origin)</small>
          </h1>
        </div>

        <div class="col-sm-2">
          <h1><span>{{orders?.returnsCount || 0}}</span>
            <small style="width:200px;margin-left:-30px">Order Returns</small>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div style="width: 75%; margin:auto;">
            <canvas id="rtoCountChart"></canvas>
          </div>
        </div>
        <div class="col-md-6">
          <div style="width: 75%; margin:auto;">
            <canvas id="returnsCountChart"></canvas>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="box mt-3" style="height:150px;">
    <h4>Accounting</h4>
    <div class="row d-flex flex-row justify-content-around">

      <div class="col-md-3">
        <div class="row d-flex flex-row" (click)="navigateToInvoice('overDue')">

          <div class="col-sm-2">
            <h5 style="margin-top:10px;">{{invoice?.invoicesOverdue || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Invoices Overdue</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M18.0625 8.29169V10.7159C18.0625 11.8992 19.0192 12.8584 20.2025 12.8617H22.4984M17.9067 18.7988H13.4067M16.2026 15.6717H13.4059M18.2814 8.30152H12.7373C11.0039 8.29485 9.58311 9.67652 9.54227 11.409V20.3365C9.50394 22.0974 10.8998 23.5565 12.6606 23.5957C12.6864 23.5957 12.7114 23.5965 12.7373 23.5957H19.3948C21.1398 23.5249 22.5148 22.0832 22.5023 20.3365V12.6982L18.2814 8.30152Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="row d-flex flex-row" (click)="navigateToInvoice('overDue')">
          <div class="col-sm-2">
            <h5 style="margin-top:10px;">₹{{invoice?.amountOverdue || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Amount Overdue</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M18.0625 8.29169V10.7159C18.0625 11.8992 19.0192 12.8584 20.2025 12.8617H22.4984M17.9067 18.7988H13.4067M16.2026 15.6717H13.4059M18.2814 8.30152H12.7373C11.0039 8.29485 9.58311 9.67652 9.54227 11.409V20.3365C9.50394 22.0974 10.8998 23.5565 12.6606 23.5957C12.6864 23.5957 12.7114 23.5965 12.7373 23.5957H19.3948C21.1398 23.5249 22.5148 22.0832 22.5023 20.3365V12.6982L18.2814 8.30152Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="row d-flex flex-row" (click)="navigateToWallet()">

          <div class="col-sm-2">
            <h5 style="margin-top:10px;">₹{{invoice?.walletBalance || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Wallet Balance</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M24.0326 17.9965H20.659C19.4203 17.9957 18.4163 16.9924 18.4155 15.7537C18.4155 14.515 19.4203 13.5118 20.659 13.511H24.0326M21.0407 15.7024H20.7809M11.8632 12.2818H16.3623M12.4566 8.5H19.6594C22.0745 8.5 24.0325 10.4579 24.0325 12.8731V18.8539C24.0325 21.269 22.0745 23.227 19.6594 23.227H12.4566C10.0414 23.227 8.0835 21.269 8.0835 18.8539V12.8731C8.0835 10.4579 10.0414 8.5 12.4566 8.5Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Shipments by Carrier</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Carrier</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let co of shipmentByCarrierInfo">
              <td>
                {{(co.carrierCode == 'SD' ? 'Shift' :
                (co.carrierCode == 'DL' ? 'Delhivery' :
                (co.carrierCode == 'GT' ? 'Gati' :
                (co.carrierCode == 'DZ' ? 'Dotzot' :
                (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                (co.carrierCode == 'SF' ? 'Shadow Fax' :
                (co.carrierCode == 'BD' ? 'Blue Dart' :
                (co.carrierCode == 'PR' ? 'Pickrr' :
                (co.carrierCode == 'SY' ? 'Ship Yaari' :
                (co.carrierCode == 'DE' ? 'Delhivery' :
                (co.carrierCode == 'SG' ? 'Shippigo' :
                (co.carrierCode == 'VS' ? 'Vamaship' :
                (co.carrierCode == 'DN' ? 'Dunzo' :
                (co.carrierCode == 'XB' ? 'Xpressbees' :
                (co.carrierCode == 'KE' ? 'Kerry Express' :
                (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))))))}}
              </td>
              <td>{{co.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="shipmentByCarrierInfo?.length===0|| !shipmentByCarrierInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Order by Store</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Store</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let st of storeInfo">
              <td>{{st.storeType}}</td>
              <td>{{st.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="storeInfo?.length===0|| !storeInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div><br>

  <div class="row" style="height:250px">
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Products</h2>

        <div class="col">
          <div class="row" *ngFor="let product of topFiveProducts">
            <div class="col-3">
              <label class="textminwid" ngxClipboard [cbContent]="product.productName"
                     ngbTooltip="{{product.productName | titlecase}}">{{product.productName}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'product.percentage'
                >
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{product.percentage}} % </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Locations</h2>
        <div class="col">
          <div class="row" *ngFor="let location of topFiveLocation">
            <div class="col-md-3">
              <label>{{location.city}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'location.noOfOrders'>
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{location.noOfOrders}} %</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="main-section dashboard-section MobileContent">
  <div class="slide mb-2">
    <div (click)="navigateToOrder('submitted')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.submittedCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="rgb(193 11 180)"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>created</small>
        </h1>
      </div>
    </div>
    <div (click)="navigateToOrder('InProcess')">
      <div class="box">
        <h1 style="z-index: 1100; min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.onHoldCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#2bedbc"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>Processing</small>
        </h1>
      </div>
    </div>
    <div (click)="navigateToOrder('shipped')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.shippedCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#f14a03"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>In Transit</small>
        </h1>
      </div>
    </div>
    <div (click)="navigateToOrder('Delivered')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.deliveredCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#07be06"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>Delivered </small>
        </h1>
      </div>
    </div>
    <div (click)="navigateToOrder('Cancelled')">
      <div class="box">
        <h1 style="z-index: 1100;min-height: 40px !important;"><span
          *ngIf="!ordersCountSpinner">{{orders?.exceptionCount || 0}}</span>
          <ngx-spinner name="ordersCountSpinner" bdColor="rgba(0,0,0,0.02)" size="default" color="#f3ed03"
                       type="line-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
          <small>With Exceptions</small>
        </h1>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 box mb-2">
      <h4>NDR</h4>
      <div class="row">
        <div class="col-sm-3">
          1st Attempt
        </div>
        <div class="col-sm-3">
          2nd Attempt
        </div>
        <div class="col-sm-3">
          3rd Attempt
        </div>
      </div>
    </div>
    <div class="col-md-6 box">
      <h4>Returns</h4>
      <div class="row">
        <div class="col-sm-2">
          <h1><span>{{orders?.rtoCount || 0}}</span>
            <small style="width:200px;">RTO (Returned to Origin)</small>
          </h1>
        </div>

        <div class="col-sm-2">
          <h1><span>{{orders?.returnsCount || 0}}</span>
            <small style="width:200px;">Order Returns</small>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="box">
      <h4>Accounting</h4>
      <div class="col-md-3">
        <div class="row" (click)="navigateToInvoice('overDue')">

          <div class="col-sm-2">
            <h5 style="margin-top:10px;">{{invoice?.invoicesOverdue || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Invoices Overdue</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M18.0625 8.29169V10.7159C18.0625 11.8992 19.0192 12.8584 20.2025 12.8617H22.4984M17.9067 18.7988H13.4067M16.2026 15.6717H13.4059M18.2814 8.30152H12.7373C11.0039 8.29485 9.58311 9.67652 9.54227 11.409V20.3365C9.50394 22.0974 10.8998 23.5565 12.6606 23.5957C12.6864 23.5957 12.7114 23.5965 12.7373 23.5957H19.3948C21.1398 23.5249 22.5148 22.0832 22.5023 20.3365V12.6982L18.2814 8.30152Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-md-3 ">
        <div class="row" (click)="navigateToInvoice('overDue')">
          <div class="col-sm-2">
            <h5 style="margin-top:10px;">₹{{invoice?.amountOverdue || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Amount Overdue</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M18.0625 8.29169V10.7159C18.0625 11.8992 19.0192 12.8584 20.2025 12.8617H22.4984M17.9067 18.7988H13.4067M16.2026 15.6717H13.4059M18.2814 8.30152H12.7373C11.0039 8.29485 9.58311 9.67652 9.54227 11.409V20.3365C9.50394 22.0974 10.8998 23.5565 12.6606 23.5957C12.6864 23.5957 12.7114 23.5965 12.7373 23.5957H19.3948C21.1398 23.5249 22.5148 22.0832 22.5023 20.3365V12.6982L18.2814 8.30152Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="row" (click)="navigateToWallet()">

          <div class="col-sm-2">
            <h5 style="margin-top:10px;">₹{{invoice?.walletBalance || 0}}</h5>
            <p style="width:240px; margin-top:10px;">Wallet Balance</p>
          </div>
          <div class="col-sm-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="4" fill="#2196F3" fill-opacity="0.08"/>
              <path
                d="M24.0326 17.9965H20.659C19.4203 17.9957 18.4163 16.9924 18.4155 15.7537C18.4155 14.515 19.4203 13.5118 20.659 13.511H24.0326M21.0407 15.7024H20.7809M11.8632 12.2818H16.3623M12.4566 8.5H19.6594C22.0745 8.5 24.0325 10.4579 24.0325 12.8731V18.8539C24.0325 21.269 22.0745 23.227 19.6594 23.227H12.4566C10.0414 23.227 8.0835 21.269 8.0835 18.8539V12.8731C8.0835 10.4579 10.0414 8.5 12.4566 8.5Z"
                stroke="#2196F3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-4">
    <div class="col-md-6 mb-2 mb-md-0">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Shipments by Carrier</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Carrier</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let co of shipmentByCarrierInfo">
              <td>
                {{(co.carrierCode == 'SD' ? 'Shift' :
                (co.carrierCode == 'DL' ? 'Delhivery' :
                (co.carrierCode == 'GT' ? 'Gati' :
                (co.carrierCode == 'DZ' ? 'Dotzot' :
                (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                (co.carrierCode == 'SF' ? 'Shadow Fax' :
                (co.carrierCode == 'BD' ? 'Blue Dart' :
                (co.carrierCode == 'PR' ? 'Pickrr' :
                (co.carrierCode == 'SY' ? 'Ship Yaari' :
                (co.carrierCode == 'DE' ? 'Delhivery' :
                (co.carrierCode == 'SG' ? 'Shippigo' :
                (co.carrierCode == 'VS' ? 'Vamaship' :
                (co.carrierCode == 'DN' ? 'Dunzo' :
                (co.carrierCode == 'XB' ? 'Xpressbees' :
                (co.carrierCode == 'KE' ? 'Kerry Express' :
                (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))))))}}
              </td>
              <td>{{co.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="shipmentByCarrierInfo?.length===0|| !shipmentByCarrierInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="box pb-0">
        <h2 class="color-3 text-capitalize mb-3">Order by Store</h2>
        <div class="table-3">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">Store</th>
              <th scope="col">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let st of storeInfo">
              <td>{{st.storeType}}</td>
              <td>{{st.quantity}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr *ngIf="storeInfo?.length===0|| !storeInfo?.length">
              <td colspan="2" class="text-center">No matching records found</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div><br>

  <div class="row" style="height:250px">
    <div class="col-md-6 mb-3">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Products</h2>

        <div class="col">
          <div class="row" *ngFor="let product of topFiveProducts">
            <div class="col-3">
              <label class="textminwid" ngxClipboard [cbContent]="product.productName"
                     ngbTooltip="{{product.productName | titlecase}}">{{product.productName}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'product.percentage'
                >
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{product.percentage}} % </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="box me-1 col rounded-sm">
        <h2 class="color-3 text-capitalize mb-3">Top 5 Locations</h2>
        <div class="col">
          <div class="row" *ngFor="let location of topFiveLocation">
            <div class="col-md-3">
              <label>{{location.city}}</label>
            </div>
            <div class="col-md-7">
              <div class="progress"style="height:10px">
                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width.%]= 'location.noOfOrders'>
                </div>
              </div>
            </div>
            <div class="col-md-2 progressBar">
              <span>{{location.noOfOrders}} %</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
